import ApiClient from "@/utils/ApiClient";

export interface RoutePayload {
  origin: [number, number];
  destination: [number, number];
  grid: string | null;
  routing_engine: string;
  min_height: number | null;
}

export interface RouteResponse {
  route: {
    geometry: {
      coordinates: [number, number][];
    };
  };
  distance: number;
}

export const SeaRouteService = {
  calculateRoute: async (payload: RoutePayload): Promise<RouteResponse> => {
    try {
      const response = await ApiClient.post(
        "/sea-routes/calculate_grid_height_based",
        payload,
        {
          headers: {
            is_admin_panel: "true",
          },
        },
      );

      const data = response.data as {
        route: {
          coordinates?: [number, number][];
          features?: Array<{
            geometry?: { coordinates?: [number, number][] };
          }>;
        };
        distanceInNauticalMiles?: number;
      };

      const geometryCoordinates =
        payload.routing_engine === "spire"
          ? data.route.coordinates
          : data.route.features?.[0]?.geometry?.coordinates;

      return {
        route: {
          geometry: {
            coordinates: geometryCoordinates ?? [],
          },
        },
        distance: data.distanceInNauticalMiles ?? 0,
      };
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : String(error);
      throw new Error(`Failed to calculate route: ${message}`);
    }
  },
};
